import { render, staticRenderFns } from "./userHead.vue?vue&type=template&id=411c686a"
import script from "./userHead.vue?vue&type=script&lang=js"
export * from "./userHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports